const getItem = (key) => {
	try {
		return localStorage.getItem(key);
	} catch (ex) {
		return null;
	}
};

const setItem = (key, data) => {
	try {
		return localStorage.setItem(key, data);
	} catch (ex) {
		return null;
	}
};

const removeItem = (key) => {
	try {
		return localStorage.removeItem(key);
	} catch (ex) {
		return null;
	}
};
export default {
	getItem,
	setItem,
	removeItem,
};
